import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@/store/useTheme'
import { useSession } from '@/store/useSession'
import styles from './SessionNotesPage.module.css'

export default function SessionNotesPage() {
  const navigate = useNavigate()
  const { palette } = useTheme()
  const { sessionNotes, followUpNotes, setSessionNotes, setFollowUpNotes, clientPostPanasScore, postSessionPanasSkipped } = useSession()

  useEffect(() => {
    if (clientPostPanasScore === null && !postSessionPanasSkipped) {
      navigate('/session/end?dest=notes', { replace: true })
    }
  }, [clientPostPanasScore, postSessionPanasSkipped, navigate])

  const paletteVars = {
    '--sn-bg':   palette.bg,
    '--sn-text': palette.text,
    '--sn-ring': palette.ring,
  } as React.CSSProperties

  return (
    <main className={styles.page} style={paletteVars} aria-label="Session notes">
      <div className={styles.inner}>
        <header className={styles.header}>
          <h1 className={styles.heading}>Session notes</h1>
          <p className={styles.subtitle}>
            A quiet place to capture what stood out, while it's still fresh.
          </p>
        </header>

        <label className={styles.field}>
          <span className={styles.fieldLabel}>Notes from this session</span>
          <textarea
            className={styles.noteArea}
            placeholder="What happened, what you noticed, what might help next time…"
            value={sessionNotes}
            onChange={e => setSessionNotes(e.target.value)}
            rows={8}
          />
        </label>

        <label className={styles.field}>
          <span className={styles.fieldLabel}>What to follow up</span>
          <textarea
            className={`${styles.noteArea} ${styles.noteAreaSmall}`}
            placeholder="Themes to revisit, check-ins, things to explore…"
            value={followUpNotes}
            onChange={e => setFollowUpNotes(e.target.value)}
            rows={4}
          />
        </label>

        <button type="button" className={styles.shareBtn} disabled title="Coming soon">
          Share with client
        </button>

        <div className={styles.actions}>
          <button type="button" className={styles.doneBtn} onClick={() => navigate('/clients')}>
            Done
          </button>
        </div>
      </div>
    </main>
  )
}
